import { useState } from 'react';
import { Outlet, Link, NavLink } from 'react-router-dom';
import logo from '@/assets/wavelengths_horizontal_logo.png';
import footerLogo from '@/assets/wavelengths_logo_white.png';
import styles from './Layout.module.css';

function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const year = new Date().getFullYear();

  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <nav className={styles.nav}>
          <Link to="/" className={styles.logoLink}>
            <img src={logo} alt="Wavelengths Hair Salon" className={styles.logoImage} />
          </Link>

          <button
            className={`${styles.hamburger} ${menuOpen ? styles.hamburgerOpen : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>

          <ul className={`${styles.navLinks} ${menuOpen ? styles.navLinksOpen : ''}`}>
            <li>
              <NavLink
                to="/"
                className={({ isActive }) => isActive ? styles.navLinkActive : styles.navLink}
                onClick={() => setMenuOpen(false)}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className={({ isActive }) => isActive ? styles.navLinkActive : styles.navLink}
                onClick={() => setMenuOpen(false)}
              >
                Contact
              </NavLink>
            </li>
            <li>
              <a
                href="https://www.facebook.com/WavelengthsBrookline/"
                className={styles.navLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
          </ul>
        </nav>
      </header>

      <main className={styles.main}>
        <Outlet />
      </main>

      <footer className={styles.footer}>
        <p className={styles.footerEstablished}>Est. 1980</p>
        <img src={footerLogo} alt="Wavelengths logo" className={styles.footerLogo} />
        <p className={styles.footerAddress}>58 Kent Street Brookline Village Studio 104</p>
        <p className={styles.footerPhone}>Call: 617-232-2116</p>
        <p className={styles.footerSocial}>
          <a
            href="https://www.facebook.com/WavelengthsBrookline/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Facebook
          </a>
        </p>
        <p className={styles.footerCopyright}>&copy; {year} Wavelengths Salon</p>
      </footer>
    </div>
  );
}

export default Layout;
